<template>
  <div>
    <inputbox
      :value="value"
      @input="emitChange"
      :name="placeholder.key"
      :label="placeholder.label"
      v-if="placeholder.type === 'text'"
    ></inputbox>

    <inputbox
      :value="value"
      @input="emitChange"
      :name="placeholder.key"
      :label="placeholder.label"
      type="phone"
      v-if="placeholder.type === 'phone'"
    ></inputbox>

    <inputbox
      :value="value"
      @input="emitChange"
      :name="placeholder.key"
      :label="placeholder.label"
      type="email"
      v-if="placeholder.type === 'email'"
    ></inputbox>

    <input-block
      :value="value"
      @input="emitChange"
      :name="placeholder.key"
      :label="placeholder.label"
      v-if="placeholder.type === 'textarea'"
    ></input-block>

    <input-block
      :value="value"
      @input="emitChange"
      :name="placeholder.key"
      :label="placeholder.label"
      v-if="placeholder.type === 'address'"
    ></input-block>

    <div class="form-group" v-if="placeholder.type === 'switch'">
      <div class="col-md-4">
        <label :for="placeholder.key" class="control-label">
          {{ placeholder.label }}
        </label>
      </div>
      <div class="col-md-8">
        <toggleswitch
          :labels="true"
          :name="placeholder.key"
          :checked="value"
          @change="emitChange"
        ></toggleswitch>
      </div>
    </div>

    <div class="form-group" v-if="placeholder.type === 'date'">
      <div class="col-md-4">
        <label :for="placeholder.key" class="control-label">
          {{ placeholder.label }}
        </label>
      </div>

      <div class="col-md-8">
        <datepicker
          :id="placeholder.key"
          format="dd/MM/yyyy"
          v-bind:value="value"
          input-class="form-control"
          @selected="emitChange"
          placeholder="dd/mm/yyyy"
        ></datepicker>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true
    },
    placeholder: {
      type: Object,
      required: true
    }
  },

  methods: {
    emitChange(value) {
      this.$emit('input', value);
    }
  }
};
</script>
